export enum OrderSync {
    Disable = 0,
    Enable = 1,
}